import revive_payload_client_4sVQNw7RlN from "C:/vnimpex/tcms-framework-test-3001/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "C:/vnimpex/tcms-framework-test-3001/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "C:/vnimpex/tcms-framework-test-3001/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "C:/vnimpex/tcms-framework-test-3001/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "C:/vnimpex/tcms-framework-test-3001/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "C:/vnimpex/tcms-framework-test-3001/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "C:/vnimpex/tcms-framework-test-3001/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import components_plugin_KR1HBZs4kY from "C:/vnimpex/tcms-framework-test-3001/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "C:/vnimpex/tcms-framework-test-3001/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_client_OVoKJro5pc from "C:/vnimpex/tcms-framework-test-3001/node_modules/@nuxtjs/color-mode/dist/runtime/plugin.client.js";
import session_client_NxDDSatxox from "C:/vnimpex/tcms-framework-test-3001/node_modules/nuxt-auth-utils/dist/runtime/app/plugins/session.client.js";
import i18n_VfGcjrvSkj from "C:/vnimpex/tcms-framework-test-3001/plugins/i18n.ts";
import tw_colors_sX4t3eM0H4 from "C:/vnimpex/tcms-framework-test-3001/plugins/tw-colors.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_client_OVoKJro5pc,
  session_client_NxDDSatxox,
  i18n_VfGcjrvSkj,
  tw_colors_sX4t3eM0H4
]